import { render } from "./ForecastBurnUpPage.vue?vue&type=template&id=2bf929c8"
import script from "./ForecastBurnUpPage.vue?vue&type=script&lang=js"
export * from "./ForecastBurnUpPage.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__